import QuerySelector from './components/querySelector';

const install = function(Vue) {
    if (install.installed) return;
    Vue.component('QuerySelector', QuerySelector);

};

// auto install
if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
}

const API = {
    version: process.env.VERSION, // eslint-disable-line no-undef
    install,
    QuerySelector
};

module.exports.default = module.exports = API;   // eslint-disable-line no-undef



// WEBPACK FOOTER //
// ./src/index.js